/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as Msdyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';

import { INosTextBlockProps, INosTextBlockConfig, ILinksData } from './nos-text-block.props.autogenerated';

export interface INosTextBlockViewProps extends INosTextBlockProps<INosTextBlockConfig> {
    paragraph?: React.ReactNode;
    pictogram?: React.ReactNode;
    className?: string;
    clientRender?: boolean;
    links?: ILinksData[];
}

/**
 *
 * TextBlock component.
 */
class NosTextBlock extends React.PureComponent<INosTextBlockProps<{}>> {
    public render(): JSX.Element | null {
        const { layout, paragraph, pictogram, links, className } = this.props.config;
        const text = paragraph && (
            <Msdyn365.RichTextComponent
                text={paragraph}
                editProps={{ onEdit: this.handleTextChange, requestContext: this.props.context.request }}
            />
        );

        const icon = pictogram && <div className='nos-text-block__pictogram' dangerouslySetInnerHTML={{ __html: pictogram }} />;

        const textBlockViewProps = {
            ...this.props,
            layout: layout,
            paragraph: text,
            pictogram: icon,
            links: links,
            className: classnames('nos-text-block', className)
        };
        return this.props.renderView(textBlockViewProps) as React.ReactElement;
    }

    public handleTextChange = (event: Msdyn365.ContentEditableEvent) => (this.props.config.paragraph = event.target.value);
}
export default NosTextBlock;
